var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.4375,
    y: 1.4375,
    width: 43.125,
    height: 43.125,
    rx: 21.5625,
    stroke: "#045B31",
    strokeWidth: 2.875
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7682 14.1647L19.0448 27.4088L15.4032 23.518C14.7323 22.8855 13.6782 22.8472 12.9115 23.3838C12.164 23.9397 11.9532 24.9172 12.4132 25.703L16.7257 32.718C17.1473 33.3697 17.8757 33.7722 18.6998 33.7722C19.4857 33.7722 20.2332 33.3697 20.6548 32.718C21.3448 31.8172 34.5123 16.1197 34.5123 16.1197C36.2373 14.3563 34.1482 12.8038 32.7682 14.1455V14.1647Z",
    fill: "#045B31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheck);
export default __webpack_public_path__ + "static/media/circle-check.4e98469a551d6538a4d66e3388bdccdd.svg";
export { ForwardRef as ReactComponent };